import React, { useState } from "react";
import {
	Button,
	Grid,
	Typography,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	AccordionActions,
	Theme,
	Grow,
	Card,
	TextField,
	FormControl
} from "@mui/material";
import {
	TextInput,
	SelectCountry,
	SelectState,
	SelectProvince,
} from "../Forms/Inputs";
import { makeStyles } from "@mui/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation, Trans } from "react-i18next";
import moment from "moment";
import { profileInfoValidate } from "./validate";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import ButtonLoader from "../../utils/ButtonLoader";
import Loader from "../../utils/Loader";
const useStyles = makeStyles((theme: Theme) => ({
	root: {
		margin: "0px",
		width: "100%",
	},
	header: {
		backgroundColor: theme.palette.primary.main,
		color: "white",
		borderTopLeftRadius: "5px",
		borderTopRightRadius: "5px",
		fontSize: 22,
		lineHeight: 1,
		margin: 0,
	},
	accordion: {
		width: "100%",
		paddingTop: "20px",
	},
	capitalize: {
		textTransform: "capitalize",
	},
}));

export default function PersonalDetails(props: any) {
	const classes = useStyles();
	useTranslation();
	const { user, userConfig } = props;
	const [values, setValues] = useState<any>({
		email: "test@test.com",
		firstName: "John",
		lastName: "Doe",
		cellPhone: "123-123-1234",
		homePhone: "",
		workPhone: "",
		dateOfBirth: "06/12/1982",
		address: "123 Street",
		zip: "b3h4j9",
		city: "Halifax",
		state: "NS",
		country: "CA",
	});
	const [selectedDate, setSelectedDate] = React.useState<any>();
	const [errors, setErrors] = React.useState<any>({});
	const handleChange = (event: any) => {
		setErrors({ ...errors, [event.target.name]: "" });
		setValues({
			...values,
			[event.target.name]: event.target.value,
		});
	};
	const handleBoolean = (prop: string, value: any) => {
		setValues({ ...values, [prop]: value });
	};

	const handleDateChange = (value: any) => {
		if (value == "Invalid Date") {
			setErrors({ ...errors, dateOfBirth: "Must select a valid date" });
		} else {
			setSelectedDate(new Date(value).toISOString().slice(0, 10));
			handleBoolean("dateOfBirth", new Date(value).toISOString().slice(0, 10));
		}
	};

	const validateInput = () => {
		let isValid: any = profileInfoValidate(values);
		setErrors({ ...errors, ...isValid });
	};
	let date: any = values.dateOfBirth ? values.dateOfBirth.slice(0, 10) : null;
	let gridProps: any = {
		xl: 3,
		lg: 4,
		md: 4,
		sm: 6,
		xs: 12,
	};
	const inputStyle: any = {
		input: { color: 'primary.contrastText', backgroundColor: "#252525", borderRadius: 2 }
	}
	return (
		<div className={classes.root}>
			<Grow in={true} timeout={400}>
				<div>
					<Card raised>
						<Accordion defaultExpanded={false}>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon style={{ color: "white" }} />}
								aria-controls="panel1a-content"
								id="panel1a-header"
								className={classes.header}
							>
								<Typography variant="h5">Personal Details</Typography>
							</AccordionSummary>
							<AccordionDetails sx={{ pb: 0 }}>
								{values ? (
									<form
										autoComplete="off"
										noValidate
										className={classes.accordion}
									>
										<Grid container spacing={2}>
											<Grid item {...gridProps}>
												<TextInput
													fullWidth
													color="secondary"
													sx={inputStyle}
													label={<Trans>First Name</Trans>}
													name="firstName"
													required
													onChange={handleChange}
													value={values.firstName}
													error={errors.firstName ? true : false}
													helperText={errors.firstName}
												/>
											</Grid>
											<Grid item {...gridProps}>
												<TextInput
													fullWidth
													color="secondary"
													sx={inputStyle}
													required
													label={<Trans>Last Name</Trans>}
													name="lastName"
													onChange={handleChange}
													value={values.lastName}
													error={errors.lastName ? true : false}
													helperText={errors.lastName}
												/>
											</Grid>
											<Grid item {...gridProps}>
												<TextInput
													fullWidth
													color="secondary"
													sx={inputStyle}
													required
													label={<Trans>Email Address</Trans>}
													name="email"
													onChange={handleChange}
													value={values.email}
													error={errors.email ? true : false}
													helperText={errors.email}
												/>
											</Grid>
											<Grid item {...gridProps}>
												<TextInput
													fullWidth
													color="secondary"
													sx={inputStyle}
													label={<Trans>Cell Phone</Trans>}
													name="cellPhone"
													onChange={handleChange}
													onBlur={validateInput}
													value={values.cellPhone}
													error={errors.cellPhone ? true : false}
													helperText={errors.cellPhone}
												/>
											</Grid>
											<Grid item {...gridProps}>
												<TextInput
													fullWidth
													color="secondary"
													sx={inputStyle}
													label={<Trans>Home Phone</Trans>}
													name="homePhone"
													onChange={handleChange}
													onBlur={validateInput}
													value={values.homePhone}
													error={errors.homePhone ? true : false}
													helperText={errors.homePhone}
												/>
											</Grid>
											<Grid item {...gridProps}>
												<TextInput
													fullWidth
													color="secondary"
													sx={inputStyle}
													label={<Trans>Work Phone</Trans>}
													name="workPhone"
													onChange={handleChange}
													onBlur={validateInput}
													value={values.workPhone}
													error={errors.workPhone ? true : false}
													helperText={errors.workPhone}
												/>
											</Grid>
											<Grid item {...gridProps}>
												<TextInput
													fullWidth
													color="secondary"
													sx={inputStyle}
													label={<Trans>Date of Birth</Trans>}
													name="dateOfBirth"
													onChange={handleChange}
													value={values.dateOfBirth}
												/>
											</Grid>
											<Grid item {...gridProps}>
												<TextInput
													fullWidth
													color="secondary"
													sx={inputStyle}
													label={<Trans>Street Address</Trans>}
													name="address"
													onChange={handleChange}
													value={values.address}
												/>
											</Grid>
											<Grid item {...gridProps}>
												<TextInput
													fullWidth
													color="secondary"
													sx={inputStyle}
													label={<Trans>City</Trans>}
													name="city"
													value={values.city}
													onChange={handleChange}
												/>
											</Grid>
											<Grid item {...gridProps}>
												<TextInput
													fullWidth
													name="zip"
													color="secondary"
													sx={inputStyle}
													label={<Trans>Zip/Postal Code</Trans>}
													onChange={handleChange}
													onBlur={validateInput}
													error={errors.zip ? true : false}
													helperText={errors.zip}
													value={values.zip}
												/>
											</Grid>
											<Grid item {...gridProps}>
												{values.country !== "US" && values.country !== "CA" ? (
													<TextInput
														fullWidth
														color="secondary"
														sx={inputStyle}
														label={<Trans>State/Province/Region</Trans>}
														name="state"
														onChange={handleChange}
														value={values.state}
													/>
												) : null}
												{values.country === "US" ? (

													<SelectState
														color="secondary"
														fullWidth
														onChange={handleChange}
														value={values.state}
														error={errors?.state ? true : false}
														helperText={errors?.state}
													/>

												) : null}
												{values.country === "CA" ? (
													<SelectProvince
														color="secondary"
														sx={inputStyle}
														onChange={handleChange}
														value={values.state}
														error={errors?.state ? true : false}
														helperText={errors?.state}
													/>
												) : null}
											</Grid>
											<Grid item {...gridProps}>
												<SelectCountry
													color="secondary"
													sx={inputStyle}
													handleChange={handleChange}
													value={values?.country}
													error={errors?.country ? true : false}
													helperText={errors?.country}
												/>
											</Grid>
											<Grid item {...gridProps} />
										</Grid>
									</form>
								) : (
									<Loader />
								)}
							</AccordionDetails>
							<AccordionActions sx={{ m: 1, mt: 0 }}>
								<Grid container justifyContent="center">
									<Grid item {...gridProps}>
										{/* <Button
											fullWidth
											onClick={() => handleUpdateProfile()}
											color="primary"
											variant="contained"
											disabled={errors.dateOfBirth}
										>
											{props.requesting ? <ButtonLoader /> : "Save"}
										</Button> */}
									</Grid>
								</Grid>
							</AccordionActions>
						</Accordion>
					</Card>
				</div>
			</Grow>
		</div>
	);
}
